import styled from 'styled-components';

const Section = styled.div`
  text-align: center;
  width: 100%;
  z-index: 1;
`;

export default Section;
